// Port of api/fuel/app/classes/filter/search/games/rules/query/year_published.php
import Rule from 'offline/filter/core/search/rule'
import F from 'offline/filter/constants'

export default Rule.create({
	name: 'year_published',
	field: function(rule) {
		var config = this._config
		if (config && config.resultType === F.RESULT_COLLECTION) {
			return '*COALESCE(v.game_version_year, g.game_published, 0)'
		}
		return '*g.game_published'
	},
	pre: function(rule, config, filter, data, query) {
		if (config.resultType === F.RESULT_COLLECTION) {
			query.join('game_version', 'v', 'LEFT JOIN', 'game_version_id')
			query.leftjoin('v', true)
		}
	}
})
